/** A presentation-only value; authoritative input and event clocks stay discrete. */
export class VisualTween {
  private from: number;
  private target: number;
  private startedAt = 0;
  constructor(initial: number, private readonly durationMs = 40) { this.from = this.target = initial; }
  sample(now: number): number {
    const progress = Math.max(0, Math.min(1, (now - this.startedAt) / this.durationMs));
    return this.from + (this.target - this.from) * progress;
  }
  set(value: number, now: number, snap = false): void {
    if (snap) { this.from = this.target = value; this.startedAt = now; return; }
    if (value === this.target) return;
    this.from = this.sample(now); this.target = value; this.startedAt = now;
  }
}
